import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { elementAt } from 'rxjs/operator/elementAt';
@Directive({
  selector: 'input[trim], textarea[trim]',
})
export class InputTrimDirective {
  constructor(private el: ElementRef, private control: NgControl) {

  }

  @HostListener('focusout', ['$event'])
  onFocusout(target: any) {
    let value = this.el.nativeElement.value;
    value = value.trim();
    this.control.control.setValue(value);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/directives/common/trim-input.directive.ts